module.exports = __webpack_public_path__ + "static/media/ice14.2871bf9c.webp";